/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { NgxValidationMessageComponent } from "./validation-message/validation-message.component";
import { NgxFilterByNumberComponent } from "./custom-smart-table-components/filter-by-number/filter-by-number.component";
import {
  NbActionsModule,
  NbBadgeModule,
  NbButton,
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbProgressBarModule,
  NbRadioModule,
  NbSpinnerModule,
  NbAccordionModule,
  NbTagModule,
  NbListModule,
  NbUserModule,
  NbTabsetModule,
  NbFormFieldModule,
  NbInputModule,
  NbCheckboxModule,
  NbSelectModule,
  NbMenuModule,
  NbAlertModule,
  NbLayoutModule,
  NbTooltipModule,
  NbContextMenuModule,
} from "@nebular/theme";
import { UploadImageComponent } from "./upload-image/upload-image.component";
import { DialogYesNoPromptComponent } from "./dialog-yesno-prompt/dialog-yesno-prompt.component";
import { ThemeModule } from "../@theme/theme.module";
import { DialogTitlePromptComponent } from "./dialog-title-prompt/dialog-title-prompt.component";

import { ViewVideoComponent } from "./view-video/view-video.component";
import { YouTubePlayerModule } from "@angular/youtube-player";
import { NgImageSliderModule } from "ng-image-slider";

import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { ViewCourseComponent } from "./view-course/view-course.component";
import { ViewImageComponent } from "./view-image/view-image.component";

import { ViewCourseInfoComponent } from "./view-course-info/view-course-info.component";
import { ViewCourseRatingComponent } from "./view-course-rating/view-course-rating.component";
import { ViewRatingComponent } from "./view-course-rating/view-rating/view-rating.component";
import { ViewRatingPlaceholderComponent } from "./view-course-rating/view-rating-placeholder/view-rating-placeholder.component";
import { ViewQnAComponent } from "./view-qnas/view-qna/view-qna.component";
import { ViewRatingStarComponent } from "./view-rating-star/view-rating-star.component";
import { ViewCourseContentComponent } from "./view-course-content/view-course-content.component";
import { DialogQuizContentComponent } from "./dialog-quiz-content/dialog-quiz-content.component";
import { DialogLinkExerciseComponent } from "./dialog-link-exercise/dialog-link-exercise.component";
import { DialogLinkQuizzesComponent } from "./dialog-link-quizzes/dialog-link-quizzes.component";
import { DialogTestQuizComponent } from "./dialog-test-quiz/dialog-test-quiz.component";
import { ViewQuizComponent } from "./view-quiz/view-quiz.component";
import { ViewQuizAnswerComponent } from "./view-quiz/view-quiz-answer/view-quiz-answer.component";
import { ViewQuizTestComponent } from "./view-quiz-test/view-quiz-test.component";
import { ViewTagsComponent } from "./view-tags/view-tags.component";
import { DialogDoExerciseComponent } from "./dialog-do-exercise/dialog-do-exercise.component";
import { ExerciseHistoryComponent } from "./view-do-exercise/exercise-history/exercise-history.component";
import { DialogQnAContentComponent } from "./dialog-qna-content/dialog-qna-content.component";
import { ViewTimeAgoComponent } from "./view-time-ago/view-time-ago.component";
import { ViewProfileComponent } from "./view-profile/view-profile.component";
import { DialogProfileComponent } from "./dialog-profile/dialog-profile.component";
import { ProfileService } from "../services/profile.service";
import { DialogReceiveGiftComponent } from "./dialog-receive-gift/dialog-receive-gift.component";
import { ViewQnAsComponent } from "./view-qnas/view-qnas.component";
import { ViewQnARepliesComponent } from "./view-qnas/view-replies/view-replies.component";
import { ViewPlaceholderComponent } from "./view-placeholder/view-placeholder.component";
import { ViewLecturesComponent } from "./view-lectures/view-lectures.component";
import { ViewCommentsComponent } from "./view-comments/view-comments.component";
import { ViewLectureComponent } from "./view-lectures/view-lecture/view-lecture.component";
import { DialogLectureContentComponent } from "./dialog-lecture-content/dialog-lecture-content.component";
import { ViewGalleryComponent } from "./view-gallery/view-gallery.component";
import { ViewExercisesComponent } from "./view-exercises/view-exercises.component";
import { ViewExerciseComponent } from "./view-exercises/view-exercise/view-exercise.component";
import { DialogAuthLoginComponent } from "./dialog-auth-login/dialog-auth-login.component";
import { ViewLikeComponent } from "./view-like/view-like.component";
import { ButtonReportSpamComponent } from "./button-report-spam/button-report-spam.component";
import { DialogReportSpamComponent } from "./dialog-report-spam/dialog-report-spam.component";
import { ViewReportsComponent } from "./view-reports/view-reports.component";
import { ViewReportedComponent } from "./view-reports/view-reported/view-reported.component";
import { DialogFeedbackComponent } from "./dialog-feedback/dialog-feedback.component";
import { ViewFeedbacksComponent } from "./view-feedbacks/view-feedbacks.component";
import { ViewFeedbackComponent } from "./view-feedbacks/view-feedback/view-feedback.component";
import { ViewNotificationsComponent } from "./view-notifications/view-notifications.component";
import { ViewNotificationComponent } from "./view-notifications/view-notification/view-notification.component";
import { DialogNotificationsComponent } from "./dialog-notifications/dialog-notifications.component";
import { ViewLectureCardComponent } from "./view-lecture-card/view-lecture-card.component";
import { ViewUserDisplayComponent } from "./view-user-display/view-user-display.component";
import { ViewQnACardComponent } from "./view-qna-card/view-qna-card.component";
import { DialogGalleryComponent } from "./dialog-gallery/dialog-gallery.component";
import { DialogExerciseComponent } from "./dialog-exercise-content/dialog-exercise-content.component";
import { ViewExerciseCardComponent } from "./view-exercise-card/view-exercise-card.component";
import { EditExerciseQuizzesComponent } from "./dialog-exercise-content/quizzes/quizzes.component";
import { ViewDoExerciseComponent } from "./view-do-exercise/view-do-exercise.component";
import { DialogAnnouncementComponent } from "./dialog-announcement/dialog-announcement.component";
import { ViewAnnouncementsComponent } from "./view-announcements/view-announcements.component";
import { ViewAnnouncementComponent } from "./view-announcements/view-announcement/view-announcement.component";
import { ViewCommentsNewComponent } from "./view-comments-new/view-comments-new.component";
import { ViewCommentComponent } from "./view-comments-new/view-comment/view-comment.component";
import { DialogImagesUploadComponent } from "./dialog-images-upload/dialog-images-upload.component";
import { ViewExerciseUserCardComponent } from "./view-exercise-user-card/view-exercise-user-card.component";
import { ViewDocumentComponent } from "./view-document/view-document.component";
import { EditorDocumentComponent } from "./editor-document/editor-document.component";
import { ButtonBookmarkComponent } from "./button-bookmark/button-bookmark.component";
import { ViewBookmarkComponent } from "./view-bookmarks/view-bookmark/view-bookmark.component";
import { ViewBookmarksComponent } from "./view-bookmarks/view-bookmarks.component";
import { ViewQuizCardComponent } from "./view-quiz-card/view-quiz-card.component";
import { ViewStudentsComponent } from "./view-students/view-students.component";
import { ViewStudentComponent } from "./view-students/view-student/view-student.component";
import { DialogInviteStudentComponent } from "./dialog-invite-student/dialog-invite-student.component";
import { DialogSortListComponent } from "./dialog-sort-list/dialog-sort-list.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { DialogPreviewCourseComponent } from "./dialog-preview-course/dialog-preview-course.component";
import { PreviewCourseSectionsComponent } from "./dialog-preview-course/sections/sections.component";
import { PreviewCourseSectionLecturesComponent } from "./dialog-preview-course/sections/lectures/lectures.component";
import { ViewCoursesComponent } from "./view-courses/view-courses.component";
import { ButtonApproveComponent } from "./button-approve/button-approve.component";
import { ViewUserCardComponent } from "./view-user-card/view-user-card.component";
import { ViewExerciseDetailComponent } from "./view-exercise-detail/view-exercise-detail.component";
import { DialogShareLinkComponent } from "./dialog-share-link/dialog-share-link.component";
import { StbCustomRenderNumberComponent } from "./smart-table-customs/custom-render-number";
import { StbCustomRenderIdComponent } from "./smart-table-customs/custom-render-id";
import { StbCustomRenderDateComponent } from "./smart-table-customs/custom-render-date";
import { StbCustomRenderCheckboxComponent } from "./smart-table-customs/custom-render-checkbox";
import { StbCustomRenderButtonComponent } from "./smart-table-customs/custom-render-button";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { DialogPreviewLectureComponent } from "./dialogs/dialog-preview-course/dialog-preview-lecture.component";

const COMPONENTS = [
  NgxValidationMessageComponent,
  NgxFilterByNumberComponent,
  UploadImageComponent,
  ViewImageComponent,
  ViewVideoComponent,
  ViewCourseComponent,
  ViewCourseInfoComponent,
  ViewCourseContentComponent,
  ViewCourseRatingComponent,
  ViewRatingComponent,
  ViewRatingPlaceholderComponent,

  ViewQnAsComponent,
  ViewQnAComponent,
  ViewQnARepliesComponent,

  DialogQnAContentComponent,

  DialogYesNoPromptComponent,
  DialogTitlePromptComponent,
  DialogQuizContentComponent,
  ViewRatingStarComponent,
  DialogLinkExerciseComponent,
  DialogLinkQuizzesComponent,
  DialogTestQuizComponent,
  ViewQuizTestComponent,
  ViewQuizComponent,
  ViewQuizAnswerComponent,
  ViewTagsComponent,
  DialogDoExerciseComponent,
  ExerciseHistoryComponent,
  ViewTimeAgoComponent,
  ViewProfileComponent,
  DialogProfileComponent,
  DialogReceiveGiftComponent,
  ViewPlaceholderComponent,

  ViewLecturesComponent,
  ViewLectureComponent,
  DialogLectureContentComponent,
  DialogPreviewLectureComponent,

  ViewCommentsComponent,
  ViewGalleryComponent,

  DialogAuthLoginComponent,
  ViewLikeComponent,
  ButtonReportSpamComponent,
  DialogReportSpamComponent,
  ViewReportsComponent,
  ViewReportedComponent,

  DialogFeedbackComponent,
  ViewFeedbacksComponent,
  ViewFeedbackComponent,

  ViewNotificationsComponent,
  ViewNotificationComponent,
  DialogNotificationsComponent,
  ViewLectureCardComponent,
  ViewQnACardComponent,
  ViewUserDisplayComponent,
  DialogGalleryComponent,

  ViewExercisesComponent,
  ViewExerciseComponent,
  DialogExerciseComponent,
  ViewExerciseCardComponent,
  EditExerciseQuizzesComponent,
  ViewExerciseUserCardComponent,
  ViewDoExerciseComponent,

  DialogAnnouncementComponent,
  ViewAnnouncementsComponent,
  ViewAnnouncementComponent,
  ViewCommentsNewComponent,
  ViewCommentComponent,

  DialogImagesUploadComponent,
  ViewDocumentComponent,
  EditorDocumentComponent,
  ButtonBookmarkComponent,
  ViewBookmarkComponent,
  ViewBookmarksComponent,

  ViewQuizCardComponent,
  ViewStudentsComponent,
  ViewStudentComponent,
  DialogInviteStudentComponent,
  DialogSortListComponent,
  DialogPreviewCourseComponent,
  PreviewCourseSectionsComponent,
  PreviewCourseSectionLecturesComponent,

  ViewCoursesComponent,
  ButtonApproveComponent,
  ViewUserCardComponent,
  ViewExerciseDetailComponent,
  DialogShareLinkComponent,

  StbCustomRenderNumberComponent,
  StbCustomRenderIdComponent,
  StbCustomRenderDateComponent,
  StbCustomRenderCheckboxComponent,
  StbCustomRenderButtonComponent,
];

const ENTRY_COMPONENTS = [
  NgxFilterByNumberComponent,
  DialogYesNoPromptComponent,
  DialogTitlePromptComponent,
];

@NgModule({
  imports: [
    ThemeModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NbCardModule,
    NbSpinnerModule,
    NbButtonModule,
    NbIconModule,
    NbRadioModule,
    NbActionsModule,
    NbBadgeModule,
    YouTubePlayerModule,
    CKEditorModule,
    NbProgressBarModule,
    NbAccordionModule,
    NbTagModule,
    NbListModule,
    NbUserModule,
    NbTabsetModule,
    NbInputModule,
    NbFormFieldModule,
    NbCheckboxModule,
    NbSelectModule,
    NbMenuModule,
    NbAlertModule,
    NbIconModule,
    NbLayoutModule,
    NbTooltipModule,
    NbContextMenuModule,
    NgImageSliderModule,
    DragDropModule,
    Ng2SmartTableModule,
  ],
  exports: [...COMPONENTS],
  declarations: [...COMPONENTS],
  entryComponents: [...ENTRY_COMPONENTS],
  providers: [ProfileService],
})
export class ComponentsModule {}
